<template>
  <div>
    <b-navbar
      toggleable="lg"
      :variant="getLayoutNavbarBg()"
      class="layout-navbar align-items-lg-center container-p-x"
    >
      <div
        class="navbar-brand app-brand demo mr-4 pt-0 pb-0"
        v-if="isMobileDevice() || orientation == 'horizontal'"
      >
        <span @click="onHomeClick" class="app-brand-logo demo bg-primary">
          <svg viewBox="0 0 80 80" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink">
            <defs>
              <linearGradient
                id="a"
                gradientUnits="userSpaceOnUse"
                x1="41.2207"
                y1="30.5288"
                x2="61.1847"
                y2="37.0155"
              >
                <stop stop-opacity=".2" stop-color="#010101" offset="0" />
                <stop stop-opacity=".1" stop-color="#010101" offset=".3" />
                <stop stop-opacity="0" stop-color="#010101" offset=".85" />
              </linearGradient>
            </defs>
            <path
              d="M80 80L53.88 5.36C52.75 2.15 49.72 0 46.32 0H33.68c-3.4 0-6.43 2.15-7.55 5.36L0 80h24l16-45.71L56 80h24z"
              fill="#fff"
            />
            <path
              d="M51 65.71l12-34.29-9.12-26.06c-.5-1.43-1.39-2.63-2.51-3.54L40 34.29l11 31.42z"
              fill="url(#a)"
            />
          </svg>
        </span>
        <span
          class="app-brand-text demo font-weight-normal ml-2"
          @click="modalTrocarEmpresa()"
          v-if="orientation == 'horizontal'"
          >{{ $store.state.user.info['empresa__nome'] }} &nbsp;
          <i class="ion ion-md-swap" v-if="getIsMultiEmpresa()"></i
        ></span>
      </div>
      <!-- Sidenav toggle (see demo.css) -->
      <b-navbar-nav class="layout-sidenav-toggle d-lg-none align-items-lg-center mr-auto" v-if="sidenavToggle">
        <a class="nav-item nav-link px-0 mr-lg-4" href="javascript:void(0)" @click="toggleSidenav">
          <i class="ion ion-md-menu text-large align-middle" />
        </a>
      </b-navbar-nav>
      <!--div class="d-lg-none" @click="modalTrocarEmpresa()">
        {{ $store.state.user.info['empresa__nome'] }} &nbsp;
        <i class="ion ion-md-swap text-lightest" v-if="getIsMultiEmpresa()"></i>
      </div-->
      <div>
        <span v-if="totalAlertas > 0" class="badge badge-danger badge-dot indicator d-lg-none"></span>
        <b-navbar-toggle target="app-layout-navbar"> </b-navbar-toggle>
      </div>

      <b-collapse is-nav id="app-layout-navbar">
        <!-- Divider -->
        <hr class="d-lg-none w-100 my-2" />

        <!-- BreadCrumbs -->
        <!-- Estas breadcrumbs sao alimentadas por uma propriedade no módulo app do Vue store.
	        Sempre que uma página é criada, no created() da mesma deverá ser chamada a função de dispatch
	        do store 'app/setCurrentPath' para que assim seja atualizado a NavBar. -->

        <div class="d-flex align-items-center w-100 mt-4 mt-md-4 mt-lg-0">
          <i class="ion ion-ios-search navbar-icon align-middle mr-2"></i>
          <sel-search-screens @selectChange="onSelectChange" :emptyLabel="'Ir para...'" :data="dataMenus" />
        </div>

        <!-- Divider -->
        <div class="nav-item d-none d-lg-block text-big font-weight-light line-height-1 opacity-25 mr-3 ml-3">
          |
        </div>

        <b-navbar-nav class="align-items-lg-center ml-auto">
          <!-- TODO: ALERTAS -->
          <b-nav-item-dropdown no-caret :right="!isRTL" class="demo-navbar-messages mr-lg-3">
            <template slot="button-content">
              <i class="ion ion-md-globe navbar-icon align-middle"></i>
              <span class="d-lg-none align-middle">&nbsp; {{ $t('Idiomas') }}</span>
            </template>

            <b-list-group flush>
              <b-list-group-item
                href="javascript:void(0)"
                v-on:click="onAlterarIdioma('pt-BR')"
                class="d-flex align-items-center"
              >
                <div class="media-body ml-3">
                  <div class="text-dark line-height-condenced">PT-BR</div>
                  <div class="text-light small mt-1" v-if="$i18n.locale == 'pt-BR'">Ativo</div>
                </div>
              </b-list-group-item>
              <b-list-group-item
                href="javascript:void(0)"
                v-on:click="onAlterarIdioma('en')"
                class="d-flex align-items-center"
              >
                <div class="media-body ml-3">
                  <div class="text-dark line-height-condenced">EN</div>
                  <div class="text-light small mt-1" v-if="$i18n.locale == 'en'">Ativo</div>
                </div>
              </b-list-group-item>
              <b-list-group-item
                href="javascript:void(0)"
                v-on:click="onAlterarIdioma('es')"
                class="d-flex align-items-center"
              >
                <div class="media-body ml-3">
                  <div class="text-dark line-height-condenced">ES</div>
                  <div class="text-light small mt-1" v-if="$i18n.locale == 'es'">Ativo</div>
                </div>
              </b-list-group-item>
            </b-list-group>
          </b-nav-item-dropdown>

          <!-- Divider -->
          <div class="nav-item d-none d-lg-block text-big font-weight-light line-height-1 opacity-25 mr-3 ml-1">
            |
          </div>

          <!-- TODO: MESSAGES -->
          <b-nav-item-dropdown v-if="false" no-caret :right="!isRTL" class="demo-navbar-messages mr-lg-3">
            <template slot="button-content">
              <i class="ion ion-ios-mail navbar-icon align-middle"></i>
              <span class="badge badge-primary badge-dot indicator"></span>
              <span class="d-lg-none align-middle">&nbsp; Messages</span>
            </template>

            <div class="bg-primary text-center text-white font-weight-bold p-3">4 New Messages</div>
            <b-list-group flush>
              <b-list-group-item href="javascript:void(0)" class="media d-flex align-items-center">
                <!-- <img :src="`${publicUrl}img/avatars/6-small.png`" class="d-block ui-w-40 rounded-circle" alt> -->
                <div class="media-body ml-3">
                  <div class="text-dark line-height-condenced">
                    Sit meis deleniti eu, pri vidit meliore docendi ut.
                  </div>
                  <div class="text-light small mt-1">Mae Gibson &nbsp;·&nbsp; 58m ago</div>
                </div>
              </b-list-group-item>

              <b-list-group-item href="javascript:void(0)" class="media d-flex align-items-center">
                <!-- <img :src="`${publicUrl}img/avatars/4-small.png`" class="d-block ui-w-40 rounded-circle" alt> -->
                <div class="media-body ml-3">
                  <div class="text-dark line-height-condenced">
                    Mea et legere fuisset, ius amet purto luptatum te.
                  </div>
                  <div class="text-light small mt-1">Kenneth Frazier &nbsp;·&nbsp; 1h ago</div>
                </div>
              </b-list-group-item>

              <b-list-group-item href="javascript:void(0)" class="media d-flex align-items-center">
                <!-- <img :src="`${publicUrl}img/avatars/5-small.png`" class="d-block ui-w-40 rounded-circle" alt> -->
                <div class="media-body ml-3">
                  <div class="text-dark line-height-condenced">
                    Sit meis deleniti eu, pri vidit meliore docendi ut.
                  </div>
                  <div class="text-light small mt-1">Nelle Maxwell &nbsp;·&nbsp; 2h ago</div>
                </div>
              </b-list-group-item>

              <b-list-group-item href="javascript:void(0)" class="media d-flex align-items-center">
                <!-- <img :src="`${publicUrl}img/avatars/11-small.png`" class="d-block ui-w-40 rounded-circle" alt> -->
                <div class="media-body ml-3">
                  <div class="text-dark line-height-condenced">
                    Lorem ipsum dolor sit amet, vis erat denique in, dicunt prodesset te vix.
                  </div>
                  <div class="text-light small mt-1">Belle Ross &nbsp;·&nbsp; 5h ago</div>
                </div>
              </b-list-group-item>
            </b-list-group>

            <a href="javascript:void(0)" class="d-block text-center text-light small p-2 my-1"
              >Show all messages</a
            >
          </b-nav-item-dropdown>

          <b-nav-item-dropdown
            no-caret
            :right="!isRTL"
            class="demo-navbar-notifications mr-lg-3 mt-3 mt-md-3 mt-lg-0"
          >
            <template slot="button-content">
              <i class="ion ion-md-notifications-outline navbar-icon align-middle"></i>
              <b-badge v-if="totalAlertas > 0" pill variant="danger indicator">
                {{ totalAlertas > 99 ? '99+' : totalAlertas }}
              </b-badge>
              <span class="d-lg-none align-middle">&nbsp; {{ $t('Notificações') }}</span>
            </template>

            <div
              v-if="totalAlertas > 0"
              :class="`
                bg-primary
                text-center text-white
                font-weight-bold
                p-3
                d-flex
                ${applyJustifyContent}
                align-items-center
              `"
            >
              <div></div>
              <span>
                {{
                  totalAlertas > 1
                    ? `${totalAlertas} ${$t('Notificações não lidas')}`
                    : `${totalAlertas} ${$t('Notificação não lida')}`
                }}
              </span>
              <b-btn
                v-if="permissions.editAlerta && totalAlertas > 1"
                class="mt-2 ml-1"
                variant="outline-white icon-btn btn-xs btn-circle borderless"
                @click="setReadAllAlerts()"
                v-b-tooltip.hover
                :title="$t('Marcar todas como lidas')"
              >
                <font-awesome-icon :icon="['fas', 'check-double']" class="" />
              </b-btn>
            </div>
            <b-list-group flush style="min-width: 350px; overflow-y: auto; max-height: calc(100vh - 180px)">
              <b-list-group-item
                v-for="(alerta, index) in alertasFiltrados"
                :key="index"
                class="media d-flex align-items-center"
                href="javascript:void(0)"
              >
                <div v-if="alerta.label == 'warning'" class="lnr lnr-warning display-4 text-warning"></div>
                <div v-else-if="alerta.label == 'danger'" class="lnr lnr-cross-circle display-4 text-danger"></div>
                <div
                  v-else-if="alerta.label == 'success'"
                  class="lnr lnr-checkmark-circle display-4 text-success"
                ></div>
                <div v-else-if="alerta.label == 'info'" class="lnr lnr-question-circle display-4 text-info"></div>
                <div
                  class="media-body line-height-condenced ml-3 cursor-pointer"
                  @click="exibirAlerta('modal-detalhe-alerta', alerta)"
                >
                  <div class="d-flex justify-content-between">
                    <span class="font-weight-bold">{{ alerta.titulo }}</span>
                    <span class="text-muted small">{{ $util.formatDateTime(alerta.momento_cadastro) }}</span>
                  </div>
                  <div class="text-light small mt-1">{{ alerta.descricao }}</div>
                </div>
                <b-btn
                  v-if="permissions.editAlerta"
                  class="mt-2 ml-1"
                  variant="outline-primary icon-btn btn-xs btn-circle borderless"
                  @click="setReadAlerta(alerta)"
                  v-b-tooltip.left
                  :title="$t('Marcar como lida')"
                >
                  <font-awesome-icon :icon="['fas', 'check']" class="" />
                </b-btn>
              </b-list-group-item>
            </b-list-group>

            <span
              v-if="totalAlertas > qtdFiltrados"
              @click="showAllAlertas()"
              class="d-block text-center text-light small cursor-pointer p-2 my-1"
            >
              {{ $t('Exibir todas as Notificações') }}
            </span>

            <span
              v-else-if="totalAlertas == 0"
              class="d-block text-center text-light small cursor-pointer p-2 my-1"
            >
              {{ $t('Sem Notificações') }}
            </span>

            <span
              v-else
              @click="colapseAlertas()"
              class="d-block text-center text-light small cursor-pointer p-2 my-1"
            >
              {{ $t('Recolher Notificações') }}
            </span>
          </b-nav-item-dropdown>

          <!-- Divider -->
          <div class="nav-item d-none d-lg-block text-big font-weight-light line-height-1 opacity-25 mr-3 ml-1">
            |
          </div>

          <b-nav-item-dropdown :right="!isRTL" class="demo-navbar-user">
            <template slot="button-content">
              <span class="d-inline-flex flex-lg-row-reverse align-items-center align-middle">
                <span class="px-1 mr-lg-2 ml-2 ml-lg-0">{{ getUserName() }}</span>
              </span>
            </template>

            <!-- <b-dd-item><i class="ion ion-ios-person text-lightest"></i> &nbsp; My profile</b-dd-item>
          <b-dd-item><i class="ion ion-ios-mail text-lightest"></i> &nbsp; Messages</b-dd-item> -->
            <div v-if="this.$util.checarAcao(129)">
              <b-dd-item @click="clickAlertas()">
                <i class="ion ion-md-notifications-outline text-lightest"></i> &nbsp; {{ $t('Notificações') }}
              </b-dd-item>
              <b-dd-divider />
            </div>
            <b-dd-item @click="modalAlterarSenha()">
              <i class="ion ion-md-key text-lightest"></i> &nbsp;{{ $t('Alterar Senha') }}
            </b-dd-item>
            <b-dd-divider />
            <div v-if="this.$util.checarAcao(280)">
              <b-dd-item @click="clickConfigEmpresa()">
                <i class="ion ion-md-settings text-lightest"></i> &nbsp; {{ $t('Configurações de Empresa') }}
              </b-dd-item>
              <b-dd-divider />
            </div>
            <div v-if="development">
              <b-dd-item @click="clickEscolherTema()">
                <i class="ion ion-ios-color-palette text-lightest"></i> &nbsp; {{ $t('Escolher Tema') }}
              </b-dd-item>
              <b-dd-divider />
            </div>
            <div v-if="this.$util.checarAcao(417)">
              <b-dd-item @click="clickNotas()">
                <i class="ion ion-ios-megaphone text-lightest"></i> &nbsp; {{ $t('Notas de Versão') }}
              </b-dd-item>
              <b-dd-divider />
            </div>
            <div v-if="exibirBotaoTemaClaroEscuro">
              <b-dd-item @click="$util.switchThemeDark()">
                <i class="ion ion-ios-contrast text-lightest"></i> &nbsp; {{ $t('Tema Claro/Escuro') }}
              </b-dd-item>
              <b-dd-divider />
            </div>
            <div v-if="this.$util.checarAcao(401)">
              <b-dd-item @click="clickTickets()">
                <i class="ion ion-ios-pricetags text-lightest"></i> &nbsp; Tickets
              </b-dd-item>
              <b-dd-divider />
            </div>
            <div v-if="getIsMultiEmpresa()">
              <b-dd-item v-if="getIsMultiEmpresa()" @click="modalTrocarEmpresa()">
                <i class="ion ion-md-swap text-lightest"></i> &nbsp; {{ $t('Trocar de Empresa') }}
              </b-dd-item>
              <b-dd-divider />
            </div>
            <b-dd-item v-on:click="logOut()">
              <i class="ion ion-ios-log-out text-lightest"></i> &nbsp; {{ $t('Sair do Sistema') }}
            </b-dd-item>
          </b-nav-item-dropdown>
        </b-navbar-nav>
      </b-collapse>
    </b-navbar>
    <modal-trocar-empresa :openModal="openModal" @closeModal="onCloseModalTrocarEmpresa" />
    <modal-alterar-senha />
    <modal-detalhe-alerta ref="modal-detalhe-alerta" />
  </div>
</template>

<script>
import ModalTrocarEmpresa from '../components/views/menu/ModalTrocarEmpresa';
import ModalAlterarSenha from '../components/views/menu/ModalAlterarSenha';
import ModalDetalheAlerta from '../components/views/menu/suporte/alertas/ModalDetalheAlerta';
import { getMenuOptions } from '../components/views/menu/sideMenuOptions';
import moment from 'moment';

export default {
  components: {
    'modal-trocar-empresa': ModalTrocarEmpresa,
    'modal-alterar-senha': ModalAlterarSenha,
    'modal-detalhe-alerta': ModalDetalheAlerta
  },

  name: 'app-layout-navbar',

  data() {
    return {
      openModal: false,
      alertas: new Array(),
      alertasFiltrados: new Array(),
      totalAlertas: 0,
      qtdFiltrados: 4,
      qtdInicialFiltrados: 4,
      permissions: {
        editAlerta: this.$util.checarAcao(415)
      },
      dataMenus: []
    };
  },
  props: {
    sidenavToggle: {
      type: Boolean,
      default: true
    },
    orientation: {
      type: String,
      default: 'vertical'
    }
  },

  computed: {
    exibirBotaoTemaClaroEscuro() {
      return this.$store.state.app.theme == 'default' || this.$store.state.app.theme == 'atena-dark';
    },
    development() {
      return process.env.VUE_APP_ENV == 'dev';
    },
    appThemes() {
      return ['default', 'atena-dark', 'atena-light', 'atena-eclipse'];
    },
    currentPath() {
      return this.$store.state.app.currentPath;
    },
    applyJustifyContent() {
      return this.permissions.editAlerta && this.totalAlertas > 1
        ? 'justify-content-between'
        : 'justify-content-center';
    }
  },

  created() {
    this.dataMenus = [];
    const copyMenuOptions = getMenuOptions();
    copyMenuOptions.push({
      menuItens: [
        {
          nome: 'Configurações de Empresa',
          path: '/empresa/configuracao',
          permissao: 280
        },
        {
          nome: 'Notificações',
          path: '/suporte/alertas/listar',
          permissao: 129
        },
        {
          nome: 'Tickets',
          path: '/suporte/tickets/listar',
          permissao: 401
        },
        {
          nome: 'Notas de Versão',
          path: '/suporte/notas/listar',
          permissao: 417
        }
      ]
    });
    const filterMenuByPermission = (arr) => {
      return arr.reduce((acc, item) => {
        const newItem = item;

        if (item?.menuItens) {
          newItem.menuItens = filterMenuByPermission(item.menuItens);
        }

        if (!newItem?.menuItens && this.$util.checarAcao(newItem?.permissao)) {
          acc.push(newItem);
          this.dataMenus.push({ ...newItem, nome: this.$t(newItem?.nome) });
        }
        return acc;
      }, []);
    };
    filterMenuByPermission([...copyMenuOptions]);

    this.getAlertas();
  },

  methods: {
    onSelectChange(name, value) {
      if (this.$router.history.current.path != value) {
        this.$router.push({ path: value });
      }
    },
    exibirAlerta(modalRef, alerta) {
      this.$refs[modalRef].show(alerta);
      this.setReadAlerta(alerta);
    },
    filterAlertas() {
      this.totalAlertas = this.alertas.length;
      this.alertasFiltrados = [];
      this.alertasFiltrados = this.alertas.filter((el, i) => {
        return i < this.qtdFiltrados;
      });
    },
    showAllAlertas() {
      this.qtdFiltrados = this.totalAlertas;
      this.filterAlertas();
    },
    colapseAlertas() {
      this.qtdFiltrados = this.qtdInicialFiltrados;
      this.filterAlertas();
    },
    setReadAllAlerts() {
      const mensagem = `${this.$i18n.t(`Deseja marcar todas as`)} ${this.totalAlertas} ${this.$i18n.t(
        'notificações como lidas?'
      )}`;
      this.$bvModal
        .msgBoxConfirm(mensagem, {
          title: this.$i18n.t('Notificações'),
          size: 'sm',
          buttonSize: 'md',
          okVariant: 'primary',
          okTitle: this.$i18n.t('Confirmar'),
          cancelTitle: this.$i18n.t('Cancelar'),
          footerClass: 'p-2',
          hideHeaderClose: false
        })
        .then((value) => {
          if (value) {
            let ids = [];
            this.alertas.forEach((item) => {
              ids.push(item.id);
            });
            const payload = {
              in: ids,
              columns: {
                lido: true,
                momento_alteracao: this.$util.formatDateTime(moment())
              }
            };
            this.$api
              .update('entity/alertas', payload)
              .then((res) => {
                this.alertas = [];
                this.alertasFiltrados = [];
                this.totalAlertas = 0;
                this.qtdFiltrados = this.qtdInicialFiltrados;
                this.$util.formWarn({
                  msgTitle: 'Sucesso',
                  msgContent: 'Todas as Notificações foram marcadas como lidas',
                  type: 'success'
                });
              })
              .catch((err) => {
                this.$util.formWarn({
                  msgTitle: 'Erro ao Atualizar Dados',
                  msgContent: 'Entre em contato com o Administrador do Sistema.',
                  type: 'error'
                });
              });
          }
        })
        .catch((err) => {
          console.log(err);
        });
    },
    setReadAlerta(alerta) {
      const idx = this.alertas.findIndex((el) => {
        return el.id == alerta.id;
      });
      this.alertas.splice(idx, 1);
      this.filterAlertas();

      const payload = {
        lido: true,
        momento_alteracao: this.$util.formatDateTime(moment())
      };

      this.$api
        .save('entity/alertas', payload, alerta.id)
        .then((res) => {})
        .catch((err) => {
          this.alertas.splice(idx, 0, alerta);
          this.filterAlertas();
          console.log(err);
          this.$util.formWarn({
            msgTitle: 'Erro ao Atualizar Dados',
            msgContent: 'Entre em contato com o Administrador do Sistema.',
            type: 'error'
          });
        });
    },
    getAlertas() {
      this.$atenaList
        .getCommon('alertas', {
          filter:
            'trade IS FALSE and lido is not true and momento_cadastro::date > current_date - 8 and (limite_premio is null or limite_premio > 10) and id_usuario_responsavel = ' +
            this.$store.state.user.info.id,
          related:
            'detalhe_alerta_defesa:limite_premio as limite_premio,id_evento_fornecedor as id_evento_fornecedor,percentual as percentual,id_alerta as id_alerta',
          order: 'momento_cadastro desc'
        })
        .then((res) => {
          this.alertas = JSON.parse(JSON.stringify(res.data));
          this.filterAlertas();
        })
        .catch((err) => {
          console.log(err);
          this.$util.formWarn({
            msgTitle: 'Atenção',
            msgContent: 'Nenhum dado foi retornado'
          });
        });
    },
    onHomeClick() {
      this.$router.replace('/');
    },

    toggleSidenav() {
      this.layoutHelpers.toggleCollapsed();
    },

    getLayoutNavbarBg() {
      return this.layoutNavbarBg;
    },

    isMobileDevice() {
      return this.layoutHelpers.isMobileDevice();
    },

    getUserName() {
      return this.$store.state.user.info.nome;
    },
    getIsMultiEmpresa() {
      return this.$store.state.user.info.multi_empresa;
    },
    modalTrocarEmpresa() {
      if (this.getIsMultiEmpresa()) {
        this.openModal = true;
      }
    },
    modalAlterarSenha() {
      this.$bvModal.show('modal-alterar-senha');
    },
    onCloseModalTrocarEmpresa() {
      this.openModal = false;
    },
    onAlterarIdioma(idioma) {
      this.$i18n.locale = idioma;
      this.$store.dispatch('user/registerTrocarIdioma', idioma);
    },
    clickConfigEmpresa() {
      this.$router.push({ path: '/empresa/configuracao' });
    },
    clickEscolherTema() {
      this.$router.push({ path: '/tema' });
    },
    clickAlertas() {
      this.$router.push({ path: '/suporte/alertas/listar' });
    },
    clickTickets() {
      this.$router.push({ path: '/suporte/tickets/listar' });
    },
    clickNotas() {
      this.$router.push({ path: '/suporte/notas/listar' });
    },
    logOut() {
      this.$auth.logout();

      this.$router.push({ path: '/' }).then(() => {
        this.$util.formWarn({
          msgTitle: 'Até logo!',
          msgContent: 'Sua sessão foi encerrada com sucesso',
          type: 'success'
        });
      });
    }
  }
};
</script>

<style lang="scss" scoped></style>
